export const filterData = [
  {
    label: "Category",
    children: [
      {
        title: "Show All",
        value: "",
      },
      {
        title: "Mens",
        value: "Men",
      },
      {
        title: "Women",
        value: "Women",
      },
      {
        title: "Unisex",
        value: "Unisex",
      },
      {
        title: "Boys",
        value: "Boys",
      },
      {
        title: "Girls",
        value: "Girls",
      },
    ],
  },
  {
    label: "Brands",
    children: [
      {
        title: "Show All",
        value: "",
      },
      {
        title: "Biba",
        value: "Biba",
      },
      {
        title: "Libas",
        value: "Libas",
      },
      {
        title: "Anouk",
        value: "Anouk",
      },
      {
        title: "SPACES",
        value: "SPACES",
      },
      {
        title: "Inddus",
        value: "Inddus",
      },
      {
        title: "SOJANYA",
        value: "SOJANYA",
      },
      {
        title: "Aj DEZInES",
        value: "Aj DEZInES",
      },
      {
        title: "Fabindia",
        value: "Fabindia",
      },
      {
        title: "DEYANN",
        value: "DEYANN",
      },
      {
        title: "Zotw",
        value: "Zotw",
      },
      {
        title: "Manu",
        value: "Manu",
      },
      {
        title: "Svanik",
        value: "Svanik",
      },
      {
        title: "Global Desi",
        value: "Global Desi",
      },
      {
        title: "IMARA",
        value: "IMARA",
      },
      {
        title: "House of Pataudi",
        value: "House of Pataudi",
      },
      {
        title: "The White Willow",
        value: "The White Willow",
      },
      {
        title: "AKS",
        value: "AKS",
      },
      {
        title: "RARE ROOTS",
        value: "RARE ROOTS",
      },
      {
        title: "I Know",
        value: "I Know",
      },
      {
        title: "SG YUVRAJ",
        value: "SG YUVRAJ",
      },
      {
        title: "TABARD",
        value: "TABARD",
      },
    ],
  },
  {
    label: "Colour",
    children: [
      {
        title: "Show All",
        value: "",
      },
      {
        title: "Navy",
        value: "Navy",
      },
      {
        title: "Black",
        value: "Black",
      },
      {
        title: "White",
        value: "White",
      },
      {
        title: "Red",
        value: "Red",
      },
      {
        title: "Green",
        value: "Green",
      },
      {
        title: "Sea Green",
        value: "Sea Green",
      },
      {
        title: "Pink",
        value: "Pink",
      },
      {
        title: "Purple",
        value: "Purple",
      },
      {
        title: "Maroon",
        value: "Maroon",
      },
      {
        title: "Yellow",
        value: "Yellow",
      },
      {
        title: "Beige",
        value: "Beige",
      },
      {
        title: "Mustard",
        value: "Mustard",
      },
      {
        title: "Coffee Brown",
        value: "Coffee Brown",
      },
      {
        title: "Grey",
        value: "Grey",
      },
      {
        title: "Olive",
        value: "Olive",
      },
      {
        title: "Blue",
        value: "Blue",
      },
      {
        title: "Orange",
        value: "Orange",
      },
      {
        title: "Turquoise Blue",
        value: "Turquoise Blue",
      },
      {
        title: "Charcoal",
        value: "Charcoal",
      },
      {
        title: "Brown",
        value: "Brown",
      },
      {
        title: "Fuchsia",
        value: "Fuchsia",
      },
    ],
  },
];
